import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

export const loadFeatureFlags = create(actions.LOAD_FEATURE_FLAGS_DATA);
export const setFeatureFlagsData = create(actions.SET_FEATURE_FLAGS_DATA);
export const setFeatureFlagsStatus = create(actions.SET_FEATURE_FLAGS_STATUS);
